import { render, staticRenderFns } from "./myClass.vue?vue&type=template&id=45ceea84&scoped=true"
import script from "./myClass.vue?vue&type=script&lang=js"
export * from "./myClass.vue?vue&type=script&lang=js"
import style0 from "./myClass.vue?vue&type=style&index=0&id=45ceea84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ceea84",
  null
  
)

export default component.exports